const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth/invitation.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { invitationTokenSchema } from '@/features/invitations/types/organizationInvitation';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute('/_auth/invitation')({
  validateSearch: z.object({
    registrationToken: invitationTokenSchema.optional().catch(undefined)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});